jQuery(function ($) {
  "use strict";

  /**
   * ファイルアップロード時の処理
   *
   * @param {*} e
   * @param {Number} sizeLimit
   * @returns {void}
   */
  const uploadFile = function(e, sizeLimit = FILE_SIZE_LIMIT) {
    var $previewPoint = "#" + e.data.paraId;
    var $iconImage = $("." + e.data.paraId.replace(/_/g, '-')); // input要素
    var $file = $iconImage[0].files[0];

    // ファイルの存在チェック
    if ($file.length === 0) {
      // inputとプレビューの中身をリセット
      $iconImage[0].value = '';
      $($previewPoint).removeAttr('src');
      $($previewPoint).removeAttr('class');
      return;
    }

    // 拡張子のチェック
    var $extension = getExtension($iconImage.prop('files')[0].name).toLowerCase();
    if (ALLOW_EXTENSIONS.indexOf($extension) === -1) {
      // inputの中身をリセットしてエラーメッセージを表示
      alert('画像のアップロードに失敗しました。\nアップロードできる画像の拡張子は、.jpg, .jpeg, .png のみ選択可能です。\n再度、画像を選択してください。');
      $iconImage[0].value = '';
      return;
    }

    // ファイルサイズのチェック
    if ($file.size > sizeLimit) {
      // inputとプレビューの中身をリセットしてエラーメッセージを表示
      if (sizeLimit === FILE_SIZE_LIMIT) {
        alert('ファイルサイズは1MB以下にしてください');
      } else if (sizeLimit === FILE_SIZE_LIMIT_2MB) {
        alert('ファイルサイズは2MB以下にしてください');
      }
      $iconImage[0].value = '';
      $($previewPoint).removeAttr('src');
      $($previewPoint).removeAttr('class');
      return;
    }

    var $reader = new FileReader();
    $reader.onload = function (e) {
      $($previewPoint).attr('src', e.target.result);
    }
    $reader.readAsDataURL(e.target.files[0]);
    return;
  };

  /**
   * ファイル名から拡張子を取得する
   *
   * @param {String} filename
   * @returns {String}
   */
  const getExtension = function(filename) {
    var $pos = filename.lastIndexOf('.');
    if ($pos === -1) return '';
    return filename.slice($pos + 1);
  }

  $(".icon-image").on('change', { paraId: "icon_image" }, uploadFile);
  $(".cover-image").on('change', { paraId: "cover_image" }, uploadFile);
  $(".thumbnail").on('change', { paraId: "thumbnail" }, uploadFile);
  $(".image-0").on('change', { paraId: "image_0" }, uploadFile);
  $(".image-1").on('change', { paraId: "image_1" }, uploadFile);
  $(".image-2").on('change', { paraId: "image_2" }, uploadFile);
  $(".image-3").on('change', { paraId: "image_3" }, uploadFile);

  $(".logo-image").on('change', { paraId: "logo" }, uploadFile);
  $(".banner-image").on('change', { paraId: "banner_image" }, uploadFile);
  $(".main-image").on('change', { paraId: "main_image" }, uploadFile);
});


// アップロードを許可する拡張子
const ALLOW_EXTENSIONS = Array('jpg', 'jpeg', 'png');

// アップロードできるファイルサイズ上限
const FILE_SIZE_LIMIT = 1048576;// 制限サイズ(1MB)
const FILE_SIZE_LIMIT_2MB = 2097152;// 制限サイズ(2MB)

/**
 * トリミングしたファイルアップロード時の処理
 *
 * @param {jQuery} $e
 * @param {String} url
 * @param {String} uploadField
 * @returns {void}
 */
export function uploadCroppedImage($e, url, uploadField, aspectRatio = 1 / 1) {
  const file = $e.prop('files')[0];

  // ファイルの存在チェック
  if (file.length === 0) {
    // inputとプレビューの中身をリセット
    $(`#${uploadField}`).removeAttr('src').removeAttr('class');
    return;
  }

  // 拡張子のチェック
  const extension = getExtension(file.name);
  if (ALLOW_EXTENSIONS.indexOf(extension) === -1) {
    // inputの中身をリセットしてエラーメッセージを表示
    alert('画像のアップロードに失敗しました。\nアップロードできる画像の拡張子は、.jpg, .jpeg, .png のみ選択可能です。\n再度、画像を選択してください。');
    return;
  }

  // ファイルサイズのチェック
  if (file.size > FILE_SIZE_LIMIT_2MB) {
    // inputとプレビューの中身をリセットしてエラーメッセージを表示
    alert('ファイルサイズは2MB以下にしてください');
    $(`#${uploadField}`).removeAttr('src').removeAttr('class');
    return;
  }

  let reader = new FileReader();
  let $image = $('#cropper_img');
  reader.onload = function (e) {
    $image.cropper('destroy').attr('src', e.target.result).cropper({
      viewMode: 0,
      dragMode: 'move',
      aspectRatio: aspectRatio,
      cropBoxMovable: false,
      cropBoxResizable: false,
      toggleDragModeOnDblclick: false,
    });
    $('#cropperModal').modal('show');
  }
  $('#cropper-trim').on('click', function () {
    const canvas = $image.data('cropper').getCroppedCanvas();
    canvas.toBlob((blob) => {
      if (blob === null || blob === undefined) {
        return;
      }
      uploadCroppedImageToServer(url, uploadField, blob);
      $(`#${uploadField}`).attr('src', canvas.toDataURL()).attr('class', "upload-image mb-1 w-full");
      $(`#${uploadField}`).parent().removeClass('hidden');
      $('#cropper-trim').off('click');
    });
  });
  reader.readAsDataURL(file);
  return;
};

/**
 * トリミングした画像をサーバーへアップロードする
 *
 * @param {String} url
 * @param {String} uploadField
 * @param {Blob} blob
 * @return {Promise}
 */
export async function uploadCroppedImageToServer(url, uploadField, blob) {
  return await new Promise(function(resolve, reject) {
    const formData = new FormData();
    formData.append('cropper_image', blob, 'cropper_image.png');
    $.ajax({
      url: url,
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      cache: false,
      headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
      }
    }).done(function(data) {
      $(`#cropped_${uploadField}`).val(data.path);
      resolve();
    }).fail(function(jqXHR, textStatus, errorThrown) {
      reject();
    });
  });
}

/**
 * ファイル名から拡張子を取得する
 *
 * @param {String} filename
 * @returns {String}
 */
export function getExtension(filename) {
  const pos = filename.lastIndexOf('.');
  if (pos === -1) {
    return '';
  }
  return filename.slice(pos + 1).toLowerCase();
}
